import axios from "services/axios";

export const getPricingAreaList = () => async dispatch => {
  dispatch(pricingAreaRequest());
  try {
    const {
      data: { areas },
    } = await axios.get("/misc/area-pricing");
    return dispatch(pricingAreaRequestSuccess({ pricingAreas: areas }));
  } catch (err) {
    return dispatch(pricingAreaRequestFailed(err));
  }
};

export const pricingAreaRequest = () => {
  return {
    type: "PRICING_AREA_LIST_REQUEST",
  };
};

export const pricingAreaRequestSuccess = payload => {
  return {
    type: "PRICING_AREA_LIST_REQUEST_SUCCESS",
    payload,
  };
};

export const pricingAreaRequestFailed = err => {
  return {
    type: "PRICING_AREA_LIST_REQUEST_FAILED",
    payload: err,
  };
};



// WEBPACK FOOTER //
// src/store/actions/area.js